export default __webpack_public_path__ + "static/images/android.b1b7c2f9.png";